import {
  FETCH_ASSESSMENT_SUMMARY_START,
  FETCH_ASSESSMENT_SUMMARY_SUCCESS,
  FETCH_ASSESSMENT_SUMMARY_FAILED,
  UPDATE_QUIZ_DESCRIPTION_SUCCESS,
  UPDATE_QUIZ_DESCRIPTION_FAILED,
} from 'chameleon-src/actionTypes';

const initialState = {
  assessmentSummaryData: {},
  isFetching: false,
  errorMessage: '',
  isFetched: false,
  userTimezone: null,
};

const assessmentSummary = (state = initialState, action) => {
  const { type, payload } = action;
  const { errorMessage, assessmentSummary, groupTimezone } = payload || {};

  switch (type) {
    case FETCH_ASSESSMENT_SUMMARY_START:
      return {
        ...initialState,
        isFetching: true,
      };
    case FETCH_ASSESSMENT_SUMMARY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        assessmentSummaryData: assessmentSummary || {},
        isFetched: true,
        userTimezone: groupTimezone,
      };
    case FETCH_ASSESSMENT_SUMMARY_FAILED:
      return {
        ...state,
        isFetching: false,
        errorMessage,
        isFetched: false,
      };
    case UPDATE_QUIZ_DESCRIPTION_SUCCESS: {
      const { assessmentSummaryData } = state;
      return {
        ...state,
        assessmentSummaryData: {
          ...assessmentSummaryData,
          itemInfo: {
            ...assessmentSummaryData.itemInfo,
            description: payload.description,
          },
        },
      };
    }
    case UPDATE_QUIZ_DESCRIPTION_FAILED:
      return {
        ...state,
        errorMessage,
      };
    default:
      return state;
  }
};

export default assessmentSummary;
